import { ReactElement } from 'react';
import { Message, useMessageGetter } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { IconInformation } from '@op/opds.opux-icons/indicator';
import { Row } from '@op/opds.opux';
import ProfitRiskChart from './ProfitRiskChart';

const ProfitAndRiskGraphs = (): ReactElement => {
  const percentages = [
    {
      x: 3.1,
      y: 4.8,
    },
    {
      x: 4.7,
      y: 9.1,
    },
    {
      x: 6.3,
      y: 15.1,
    },
    {
      x: 6.4,
      y: 29.9,
    },
  ];

  const fixedData = {
    expected: [5000, 5156, 5831, 6802],
    upper: [5000, 5559, 6878, 8563],
    lower: [5000, 4773, 4892, 5288],
  };

  const balancedData = {
    expected: [5000, 5235, 6289, 7910],
    upper: [5000, 6011, 8481, 11942],
    lower: [5000, 4524, 4493, 4862],
  };

  const diversifiedData = {
    expected: [5000, 5313, 6774, 9177],
    upper: [5000, 6641, 10849, 17347],
    lower: [5000, 4166, 3826, 3972],
  };

  const stockData = {
    expected: [5000, 5322, 6829, 9326],
    upper: [5000, 8064, 15570, 26764],
    lower: [5000, 3255, 2047, 1519],
  };

  const getAltText = useMessageGetter('course2.part1.profitAndRiskGraphs.alt_texts');

  return (
    <div
      style={{
        textAlign: 'center',
        marginTop: space.default,
        marginBottom: space.default,
      }}
    >
      <h3 className="investoracademy-title-xl">
        <Message id="course2.part1.profitAndRiskGraphs.title" />
      </h3>
      <p className="investoracademy-text-paragraph">
        <Message id="course2.part1.profitAndRiskGraphs.subtitle" />
      </p>
      <Row style={{ marginTop: space.xl, marginLeft: 0, marginRight: 0 }}>
        <ProfitRiskChart
          title="course2.part1.profitAndRiskGraphs.bond_fund"
          percentages={percentages[0]}
          data={fixedData}
          className="investoracademy-multi-column-left-small-padding"
          altText={getAltText('bond_fund')}
        />
        <ProfitRiskChart
          title="course2.part1.profitAndRiskGraphs.balanced_fund"
          percentages={percentages[1]}
          data={balancedData}
          className="investoracademy-multi-column-right-small-padding"
          altText={getAltText('balanced_fund')}
        />
        <ProfitRiskChart
          title="course2.part1.profitAndRiskGraphs.diversified_stock_fund"
          percentages={percentages[2]}
          data={diversifiedData}
          className="investoracademy-multi-column-left-small-padding"
          altText={getAltText('diversified_stock_fund')}
        />
        <ProfitRiskChart
          title="course2.part1.profitAndRiskGraphs.individual_stock"
          percentages={percentages[3]}
          data={stockData}
          className="investoracademy-multi-column-right-small-padding"
          altText={getAltText('individual_stock')}
        />
      </Row>
      <p
        className="opds-styles-v1-text-label-small"
        style={{ display: 'flex', paddingBottom: space.default, textAlign: 'left' }}
      >
        <IconInformation />
        <Message id="course2.part1.profitAndRiskGraphs.sources" />
      </p>
    </div>
  );
};

export default ProfitAndRiskGraphs;
